var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavAiAgents = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.087 1.003c.187.015.368.08.525.186.158.106.287.251.376.423a1.21 1.21 0 0 1-.238 1.431v1.47h3.75c.597 0 1.169.246 1.59.685.423.439.66 1.035.66 1.656v7.805a2.39 2.39 0 0 1-.66 1.655c-.421.439-.993.686-1.59.686h-9a2.207 2.207 0 0 1-1.59-.686 2.39 2.39 0 0 1-.66-1.655V6.854c0-.621.237-1.217.66-1.656a2.207 2.207 0 0 1 1.59-.686h3.75V3.043a1.175 1.175 0 0 1-.31-.478 1.216 1.216 0 0 1 .166-1.105c.114-.155.264-.278.435-.358.171-.08.359-.114.546-.099ZM7.5 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 8.414a.75.75 0 0 1 .75.75v3.184a.75.75 0 0 1-1.5 0V9.164a.75.75 0 0 1 .75-.75ZM18.25 8.414a.75.75 0 0 1 .75.75v3.184a.75.75 0 0 1-1.5 0V9.164a.75.75 0 0 1 .75-.75Z",
  fill: "currentColor"
})));
SvgNavAiAgents.displayName = "SvgNavAiAgents";
export { SvgNavAiAgents as ReactComponent };
export default SvgNavAiAgents;